import { render, staticRenderFns } from "./PanelTitle.vue?vue&type=template&id=1b338c95&scoped=true&"
import script from "./PanelTitle.vue?vue&type=script&lang=ts&"
export * from "./PanelTitle.vue?vue&type=script&lang=ts&"
import style0 from "./PanelTitle.vue?vue&type=style&index=0&id=1b338c95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b338c95",
  null
  
)

export default component.exports